import {Component, Input, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {CompetitionService, ECaseSnackBarService} from 'synto-common';
import {AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators} from '@angular/forms';

@Component({
  selector: 'ecase-add-approval-cycle-dialog',
  templateUrl: './ecase-add-approval-cycle-dialog.component.html',
  styleUrls: ['./ecase-add-approval-cycle-dialog.component.scss']
})
export class AddEcaseApprovalCycleDialogComponent implements OnInit {
  @Input() row;
  @Input() currentApprovalCycles: any[];
  @Input() cpmCompetition?: number;
  @Input() approvalCycleTypeId?: number;
  addUpdateCycleDescriptionForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddEcaseApprovalCycleDialogComponent>,
    public eCaseSnackBarService: ECaseSnackBarService,
    public formBuilder: FormBuilder,
    public competitionService: CompetitionService) {
  }

  ngOnInit(): void {
    const obj = {
      description: [this.row && this.row.description ? this.row.description : '', [Validators.required, this.detectDuplications]]
    };
    this.addUpdateCycleDescriptionForm = this.formBuilder.group(obj);
  }

  getTextLength(form, field): number {
    try {
      return form.controls[field].value ? form.controls[field].value.length : 0;
    } catch (e) {
      return 0;
    }
  }

  detectDuplications: ValidatorFn = (control: AbstractControl) => {
    if (!control.parent || !control) {
      return;
    }
    if (control.parent.controls['description']) {
      const description = control.parent.controls['description'].value;
      if (this.currentApprovalCycles.some(e => e.description.toLowerCase().trim() === description.toLowerCase().trim())) {
        return {duplicateDescription: true};
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  onConfirm(): void {
    const id = (this.row === 0 || (this.row && this.row.id)) ? this.row.id : -1;
    this.competitionService.addOrUpdateApprovalCycle(
      id,
      this.addUpdateCycleDescriptionForm.controls.description.value,
      this.resolvedCpmCompetitionId(),
      this.resolvedApprovalCycleTypeId())
      .subscribe((response: any) => {
        if (response.status) {
          this.dialogRef.close(true);
          this.eCaseSnackBarService.show('success');
        } else {
          this.eCaseSnackBarService.show('failure', response.errorMessage);
        }
      });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  private resolvedCpmCompetitionId(): number {
    return this.cpmCompetition != null ? Number(this.cpmCompetition) : Number(this.competitionService.competitionId);
  }

  private resolvedApprovalCycleTypeId(): number | undefined {
    const fromRow = this.row?.approvalCycleTypeId ?? this.row?.cycleTypeId;
    if (fromRow != null && fromRow !== '') {
      const n = Number(fromRow);
      return Number.isNaN(n) ? undefined : n;
    }
    if (this.approvalCycleTypeId != null && !Number.isNaN(Number(this.approvalCycleTypeId))) {
      return Number(this.approvalCycleTypeId);
    }
    return undefined;
  }
}
